export default __webpack_public_path__ + "static/media/back.a9949839.svg";